// Sample testimonial data
export interface Testimonial {
  id: number;
  quote: string;
  author: string;
  role: string;
  company: string;
}

export const testimonials: Testimonial[] = [
  {
    id: 1,
    quote: "Bare simplified our payment process and reduced our transaction costs by 30%. The setup was incredibly easy and our customers love the seamless checkout experience.",
    author: "Sarah Johnson",
    role: "CEO",
    company: "Craft Commerce"
  },
  {
    id: 2,
    quote: "We switched to Bare last year and haven't looked back. The direct bank payments have significantly improved our cash flow and the lower fees mean we can offer better prices to our customers.",
    author: "Michael Chen",
    role: "Finance Director",
    company: "TechSolutions Inc."
  },
  {
    id: 3,
    quote: "As a freelancer, getting paid quickly is crucial. With Bare, I receive payments directly to my bank account the same day. It's been a game-changer for my business.",
    author: "Emma Rodriguez",
    role: "Independent Designer",
    company: "Studio ER"
  },
  {
    id: 4,
    quote: "The analytics dashboard gives me valuable insights into my business that I never had before. I can see exactly when payments come in and plan accordingly.",
    author: "David Thompson",
    role: "Owner",
    company: "Thompson Consulting"
  },
  {
    id: 5,
    quote: "We were hesitant to switch payment providers, but Bare's customer support made the transition seamless. Their team was there every step of the way.",
    author: "Olivia Williams",
    role: "Operations Manager",
    company: "Wellness Collective"
  },
  {
    id: 6,
    quote: "The security features give both us and our customers peace of mind. The open banking integration means we don't have to worry about storing sensitive payment information.",
    author: "James Wilson",
    role: "CTO",
    company: "SecureShop"
  }
];

export default testimonials;
